export const createStocktakeDetailStyles = ({ ui: { colors, type, space, radius, touch, elevation, layout } }) => ({
	container: {
		flex: 1,
	},
	list: {
		flex: 1,
	},
	listContent: {
		paddingHorizontal: space.gutter,
		paddingTop: 20,
		paddingBottom: space.xl,
	},
	header: {
		gap: space.md,
		marginBottom: space.lg,
	},
	titleBlock: {
		gap: space.xs,
	},
	titleRow: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: space.md,
	},
	headingText: {
		...type.title,
		color: colors.text,
		flexShrink: 1,
	},
	subheadingText: {
		...type.bodySmall,
		color: colors.textSecondary,
	},
	metaText: {
		...type.secondary,
		color: colors.textSecondary,
	},
	noticeCard: {
		paddingVertical: space.md,
	},
	summaryRow: {
		flexDirection: 'row',
		gap: space.sm,
	},
	summaryTile: {
		flex: 1,
		padding: 14,
		borderRadius: radius.hero,
		backgroundColor: colors.card,
		gap: space.xxs,
	},
	summaryLabel: {
		...type.caption,
		color: colors.textSecondary,
	},
	summaryValue: {
		...type.cardTitle,
		color: colors.text,
	},
	warningText: {
		...type.secondary,
		color: colors.warning,
	},
	toggleRow: {
		minHeight: touch.min,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: space.md,
	},
	toggleLabel: {
		...type.bodySmall,
		color: colors.text,
		flexShrink: 1,
	},
	buttonRow: {
		flexDirection: 'row',
		gap: space.sm,
	},
	halfButton: {
		flex: 1,
	},
	zeroItemButton: {
		marginTop: space.md,
	},
	itemCard: {
		backgroundColor: colors.raised,
		padding: 14,
		marginBottom: space.sm,
		borderRadius: radius.card,
		borderWidth: 1,
		borderColor: colors.raisedBorder,
	},
	itemCardCompleted: {
		borderColor: colors.success,
	},
	itemName: {
		...type.rowTitleSemibold,
		color: colors.text,
	},
	itemBarcode: {
		...type.secondary,
		color: colors.textSecondary,
		marginTop: space.xxs,
	},
	itemHeaderRow: {
		flexDirection: 'row',
		alignItems: 'center',
		marginBottom: space.sm,
	},
	itemHeaderContent: {
		flex: 1,
	},
	itemImage: {
		width: 48,
		height: 48,
		borderRadius: radius.tag,
		marginRight: space.md,
		backgroundColor: colors.card,
	},
	itemImagePlaceholder: {
		borderWidth: 1,
		borderColor: colors.border,
	},
	itemMetaRow: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		marginTop: space.xs,
	},
	itemMetaBlock: {
		flex: 1,
		minWidth: 140,
		marginBottom: space.sm,
	},
	itemMetaBlockSpacing: {
		marginRight: space.md,
	},
	itemMetaBlockFull: {
		flexBasis: '100%',
	},
	itemMetaLabel: {
		...type.overline,
		color: colors.textSecondary,
		textTransform: 'uppercase',
	},
	itemMetaValue: {
		...type.secondaryStrong,
		color: colors.text,
		marginTop: space.xxs,
	},
	editHint: {
		...type.caption,
		marginTop: space.xs,
		color: colors.accent,
	},
	emptyState: {
		gap: space.lg,
		paddingTop: space.lg,
	},
	dialogTitle: {
		...type.cardTitle,
		marginBottom: space.sm,
		paddingRight: touch.min,
		color: colors.text,
	},
	dialogMeta: {
		...type.secondary,
		color: colors.textSecondary,
		marginBottom: space.xs,
	},
	dialogProductImage: {
		width: 80,
		height: 80,
		borderRadius: radius.card,
		marginBottom: space.md,
	},
	batchDialogContent: {
		paddingBottom: space.lg,
	},
	batchDialogContainer: {
		maxHeight: '82%',
	},
	batchDialogScroll: {
		flexGrow: 0,
	},
	batchRow: {
		borderWidth: 1,
		borderColor: colors.raisedBorder,
		backgroundColor: colors.raised,
		borderRadius: radius.card,
		padding: space.md,
		marginTop: space.md,
	},
	batchHeading: {
		...type.overline,
		color: colors.textSecondary,
		textTransform: 'uppercase',
		marginBottom: space.sm,
	},
	batchInput: {
		marginTop: space.sm,
		marginBottom: space.xs,
	},
	batchFooter: {
		marginTop: space.md,
	},
	batchTotalText: {
		...type.secondary,
		marginTop: space.sm,
		color: colors.textSecondary,
	},
	errorText: {
		...type.secondary,
		color: colors.danger,
		marginTop: 6,
	},
	dialogButtonRow: {
		marginTop: space.md,
		flexDirection: 'row',
		alignItems: 'center',
		gap: space.sm,
	},
	scannerContainer: {
		height: 400,
		justifyContent: 'center',
		backgroundColor: colors.surface,
		borderRadius: radius.hero,
		overflow: 'hidden',
	},
	scannerHint: {
		...type.bodySmall,
		textAlign: 'center',
		marginTop: space.sm,
		paddingHorizontal: space.lg,
		color: colors.textSecondary,
	},
	scannerMiss: {
		color: colors.warning,
	},
	scannerCamera: {
		height: 320,
	},
	manualSelectSearchInput: {
		marginTop: space.md,
		marginBottom: space.md,
	},
	manualSelectList: {
		maxHeight: 320,
	},
	manualSelectItem: {
		marginBottom: space.sm,
	},
	manualSelectEmptyText: {
		...type.bodySmall,
		textAlign: 'center',
		color: colors.textSecondary,
		marginTop: space.sm,
	},
	manualModalBackdrop: {
		flex: 1,
		backgroundColor: colors.overlay,
		justifyContent: 'center',
		alignItems: 'center',
		padding: space.lg,
	},
	manualModalOverlay: {
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
	},
	manualModalContent: {
		width: '100%',
		maxWidth: layout.maxContentWidth,
		maxHeight: '80%',
		backgroundColor: colors.surface,
		borderRadius: radius.hero,
		padding: 20,
		...elevation.floating,
	},
});
